module.exports = __webpack_public_path__ + "media/assets/images/Logo_Alux-8e7246b3beec3cdbaa0011886404ff0b.jpg";